<template>
    <div class="main-content scroll">
        <Loading v-show="loading"/>

        <div class="funnel_steps_top" v-if="getSingleStepStore">
	        <v-button :locked="!is('editor')"
			        @click="$router.push(`/funnel/${$route.params.id}/steps/${$route.params.step}/settings`)"
			        :icon="require('@/assets/img/settings_btn.svg')" flat class="small-btn settings_btn" />

            <div class="left_img_wrpr" style="position: relative;">
                <img :src="singleStep.thumbnail_hash"
                     alt="" @load="imageLoading=false">
              <loading v-if="!show && imageLoading && !loading"></loading>
            </div>

            <div class="right">
                <div class="funnel_tag_wrpr">
                    <div class="funnel_tag">
                        <span class="icon">
                            <inline-svg :src="stepTypeDetails.img"/>
                        </span>
                        {{ stepTypeDetails.title }}
                    </div>
                </div>
                <h3>{{ getSingleStepStore.name || ''}}</h3>
                <div class="funnel_steps_urls_wrpr" v-if="(getSingleStepStore.url || getSingleStepStore.url2)">
                    <div class="funnel_steps_url_item">
                        <span class="item_title">Step URL</span>
                        <div class="links-items-group">
                            <a :href="'http://'+getSingleStepStore.url" target="_blank" class="link_item">{{getSingleStepStore.url}}</a>
                            <input type="hidden" id="step_url_hidden" :value="getSingleStepStore.url">
                            <div class="icon icon-circle pointer" @click="copyToClipboard('#step_url_hidden')">
                                <inline-svg :src="require('@/assets/img/copy_icon_sm.svg')"/>
                            </div>
                            <a :href="'http://'+getSingleStepStore.url" target="_blank" class="icon icon-circle pointer">
                                <inline-svg :src="require('@/assets/img/external_link_icon.svg')"/>
                            </a>
                        </div>
                    </div>
                    <div class="funnel_steps_url_item" v-if="getSingleStepStore.url2">
                        <span class="item_title">Step Variant URL</span>
                        <div class="links-items-group">
                            <a :href="'http://'+getSingleStepStore.url2" target="_blank" class="link_item">{{getSingleStepStore.url2}}</a>
                            <input type="hidden" id="step_variant_url_hidden" :value="getSingleStepStore.url2">
                            <div class="icon icon-circle pointer" @click="copyToClipboard('#step_variant_url_hidden')">
                                <inline-svg :src="require('@/assets/img/copy_icon_sm.svg')"/>
                            </div>
                            <a :href="'http://'+getSingleStepStore.url2" target="_blank" class="icon icon-circle pointer">
                                <inline-svg :src="require('@/assets/img/external_link_icon.svg')"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- STEP CAN HAVE PRODUCTS -->
        <div class="panel funnels-panel products_panel" v-if="getSingleStepStore && canHaveProducts(getSingleStepStore.step_type)">
            <div class="panel-head">
                <h2>Products
                    <Tooltip side='right'> Products in your funnel step</Tooltip>
                </h2>
              <v-button @click="createProductOpen=true" :locked="!is('editor')" label="Add a new product" />
            </div>
		        <CreateProductPopup  v-if="createProductOpen===true" :productsLength="getObProducts.length + otherProds.length"
	                             @close="createProductOpen=false" @created="createProductOpen=false" />

            <!-- Orderbump -->
            <div class="panel-body panel-body_2 ordered-body entries-table" v-if="getObProducts.length">
<!--               TODO: <ProductEntry v-for="(item, index) in getObProducts" :key="item.id" :product="item"></ProductEntry>-->
                <div class="entry panel-item" v-for="(item, index) in getObProducts" :key="item.id" >
                    <router-link class="list-item-link cell" :to="{ path: `/funnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}">
                        <div class="products_panel_first_cell cell">
                            <div class="products_panel_square_label">
                                <img :src="require('@/assets/img/ob_label.svg')" alt="">
                            </div>
                        </div>
                        <div class="panel-item-cell cell">
                            <div class="product_panel_link">{{item.name}}</div>
                            <span class="result-tag">
                                {{item.is_subscription ? 'Subscription' : 'One-time'}}
                            </span>
                        </div>
                        <div class="panel-item-cell product-price-cell cell" v-if="item.is_subscription">
                            <h3 class="price">{{currencySymbol+' '+item.billing_amount}}</h3>
                            <span class="products_panel_weeks">
                                {{item.billing_cycle}}
                                {{ getCycleType(item.cycle_type) }}
                            </span>
                        </div>
                        <div class="panel-item-cell product-price-cell cell" v-else>
                            <h3 class="price">{{currencySymbol+' '+item.price}}</h3>
                        </div>
                    </router-link>
                    <div class="panel_item_btn_wrpr cell">
                        <a @click.prevent="showCloneProductPopup(item)" class="panel_item_btn copy_btn"
                           :class="{'disabled':!is('editor')}">
                            <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
                        </a>
                        <a @click.prevent="showProductDeletePopup(item.id)" class="panel_item_btn delete_btn"
                           :class="{'disabled':!is('editor')}">
                            <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                        </a>
                    </div>
                </div>
            </div>
            <!-- Other products -->
            <div class="panel-body panel-body_2 ordered-body entries-table" v-if="otherProds.length">
                <Container @drop="onDrop" lock-axis="y">
                    <Draggable v-for="(item, index) in otherProds" :key="item.id" class="product-result-item">
                        <div class="panel-item entry">
                            <router-link class="list-item-link" :to="{ path: `/funnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}">
                                <div class="products_panel_first_cell">
                                    <div class="number">#{{index + 1}}</div>
                                </div>
                                <div class="panel-item-cell">
                                    <div class="product_panel_link">
                                        {{item.name}}
                                    </div>
                                    <span class="result-tag">
                                        {{item.is_subscription ? 'Subscription' : 'One-time'}}
                                    </span>
                                </div>
                                <div class="panel-item-cell product-price-cell" v-if="item.is_subscription">
                                    <h3 class="price">{{currencySymbol+' '+item.billing_amount}}</h3>
                                    <span class="products_panel_weeks">
                                        {{item.billing_cycle}}
                                        {{ getCycleType(item.cycle_type) }}
                                    </span>
                                </div>
                                <div class="panel-item-cell product-price-cell" v-else>
                                    <h3 class="price">{{currencySymbol+' '+item.price}}</h3>
                                </div>
                            </router-link >
                            <div class="panel_item_btn_wrpr">
                                <a @click.prevent="showCloneProductPopup(item)" class="panel_item_btn copy_btn"
                                   :class="{'disabled':!is('editor')}">
                                    <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
                                </a>
                                <a @click.prevent="showProductDeletePopup(item.id)" class="panel_item_btn delete_btn"
                                   :class="{'disabled':!is('editor')}">
                                    <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                                </a>
                            </div>
                        </div>
                    </Draggable>
                </Container>
            </div>

            <div class="panel-body panel-body_2 empty-panel" v-else>
                <p>No products have been added yet</p>
            </div>

        </div>

        <!-- STEP CAN'T HAVE PRODUCTS -->
        <div class="panel funnels-panel products_panel" v-else>
            <div class="panel-head">
                <h2>Products
                    <Tooltip side='right'>
                        Products in your funnel step
                    </Tooltip>
                </h2>
                <a class="btn disabled">Add a new product</a>
            </div>

            <div class="panel-body panel-body_2 empty-panel">
                <p>This step cannot have products, only <b>Order forms</b>, <b>Upsells</b> and <b>Downsells</b> may have products.</p>
            </div>
        </div>

        <!-- PRODUCT DETAILS || STEP SETTINGS -->
        <router-view v-if="show" :products="otherProds" :funnelStep="singleStep"/>

        <!-- POPUPS -->
        <div class="popup_wrpr delete_popup_wrpr add_new_funnel_popup" :class="{active: getProductDeletePopup}">
            <ProductDeletePopup :productId="productId" v-if="getProductDeletePopup"
            :step-id="singleStep.step_id" :funnel-id="singleStep.funnel_id"/>
        </div>

        <div class="popup_wrpr add_new_funnel_popup" :class="{active: getCloneProductPopup}">
            <CloneProductPopup v-if="getCloneProductPopup" :product="productClone"
               :step-id="singleStep.step_id" :funnel-id="singleStep.funnel_id" />
        </div>
    </div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import ActivateAutomationPopup from "@/components/popups/automation/ActivateAutomationPopup.vue";
import ProductDeletePopup from "@/components/popups/delete/ProductDeletePopup.vue"
import CloneProductPopup from "@/components/popups/clone_product_popup"
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import {getSymbol} from "@/helpers/currencies"
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag } from '@/helpers/sort'
import stepTypes from "@/helpers/stepTypes"
import Tooltip from "@/components/Tooltip.vue"
import ProductEntry from "@/components/base/product-entry";
import CreateProductPopup from "@/views/funnels/steps/create_product_popup";
import VButton from "@/components/base/v-button";
import {is} from "@/helpers/roles";

export default {
    name: "FunnelSteps",
    components: {
	    VButton,
        CreateProductPopup,
        ProductEntry,
        MainSearch,
        Loading,
        ActivateAutomationPopup,
        ProductDeletePopup,
        CloneProductPopup,
        Container, Draggable,
        Tooltip
    },
    mixins: [API],
    props: ['step'],
    data: function() {
        return {
          imageLoading: true,
            createProductOpen: false,
            show: false,
            currentAutomation: false,
            isDragging: false,
            showEdit: false,
            loading: true,
            oldList: [],
            funnel: {},
            stepData: [],
            singleStep: {
            },
            products: [],
            otherProds: [],
            currentProduct: {},
            productId: this.$route.params.productId,
            productClone: {},
            userData: {
                "id": "",
            }
        };
    },
    computed: {
	    stepTypeDetails() {
		    let type = this.getSingleStepStore.step_type

		    if (type > 0) type -= 1;
		    if (type >= stepTypes.length || !type) type = 0;

		    return stepTypes[type];
	    },
        currencySymbol() {
            var symbol;
            if(this.getFunnelStore.currency_code !== "") {
                symbol = getSymbol(this.getFunnelStore.currency_code);
            } else {
                symbol = '$';
            }
            return symbol
        },
        ...mapGetters([
            "getProductSettingsPopup",
            "getFunnelSettingPopup",
            "getActivateAutomationPopup",
            "getAddNewStepPopup",
            "getProductDeletePopup",
            "getStepDataStore",
            "getSingleStepStore",
            "getProductsStore",
            "getFunnelStore",
            "getCloneProductPopup"
        ]),
        getObProducts() {
            if(this.getProductsStore && this.getProductsStore.length) {
                console.log(this.getProductsStore);
                return this.sortProducts(this.getProductsStore.filter(item => item.is_ob));
            } else return []

        },
        getOtherProducts() {
            if(this.getProductsStore && this.getProductsStore.length) {
                console.log(this.getProductsStore);
                return this.sortProducts(this.getProductsStore.filter(item => !item.is_ob));
            } else return []
        }
    },
    watch: {
        step(val) {
            this.loading = true;
            this.singleStep = {  };
            this.init(val);
        },
        getOtherProducts(val) {
            this.otherProds = val;
        }
    },
    methods: {
    	is(role){
    		return is(role)
	    },
        canHaveProducts(id) {
            if(id) {
                switch (parseInt(id)) {
                    case 1: // order form
                    case 2: // upsell
                    case 4: // downsell
                        return true
                    break;
                    default:
                        return false
                }
            } else return false
        },
        sortProducts(arr) {
            function compare(a, b) {
              if (a.order_index < b.order_index) return -1;
              if (a.order_index > b.order_index) return 1;
              return 0;
            }
            return arr.sort(compare);
        },
        async onDrop (dropResult) {
            if(dropResult.removedIndex !== dropResult.addedIndex) {
                this.otherProds = applyDrag(this.otherProds, dropResult);

                var first = this.otherProds[dropResult.removedIndex];
                var second = this.otherProds[dropResult.addedIndex];

                var firstOrder = first.order_index;
                var secondOrder = second.order_index;

                first.order_index = secondOrder;
                second.order_index = firstOrder;

                this.otherProds.forEach(async (item, index) => {
                    item.order_index = index + 1;
                    var update = await this.api.steps.patchProduct(item.id, item);
                })

                // var resFirst = await this.api.steps.patchProduct(first.id, first);
                // var resSecond = await this.api.steps.patchProduct(second.id, second);

                // this.$store.dispatch('EDIT_PRODUCT', resFirst.data);
                // this.$store.dispatch('EDIT_PRODUCT', resSecond.data);
            }
        },
        getCycleType(type) {
            var string = '';
            switch (type) {
                case 1:
                    string = ' day(s)';
                    break;
                case 2:
                    string = ' week(s)';
                    break;
                case 3:
                    string = ' month(s)';
                    break;
                case 4:
                    string = ' year(s)';
                    break;
            }
            return string
        },
        showAddNewStepPopup() {
            this.$store.commit("showAddNewStepPopup");
        },
        showProductDeletePopup(thisProductId) {
            this.productId = thisProductId;
            this.$store.commit("showProductDeletePopup");
        },
        showCloneProductPopup(item) {
            this.productClone = item;
            this.$store.commit("showCloneProductPopup");
        },
        copyToClipboard(queryElem) {
            let elemToCopy = document.querySelector(queryElem);
            elemToCopy.setAttribute('type', 'text');
            elemToCopy.select();

            try {
                var successful = document.execCommand('copy');

            } catch (err) {
                alert('Oops, unable to copy');
            }

            elemToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        async init(step) {
          this.imageLoading = true;
            var res = await this.api.steps.get(step);
            this.$store.dispatch('setSingleStepStore', res);

            var check = await this.canHaveProducts(res.step_type);
            if(check) {
                var prodRes = await this.api.steps.getProducts(step);
                this.$store.dispatch('setProductsStore', prodRes);
                // this.products = await this.sortProducts(prodRes.data);
                // this.otherProds = this.getOtherProducts;
            }
            this.singleStep = await res;

            this.$nextTick(()=> {
                this.loading = false;
                this.show = true;
            });

        },
    },
    created() {
        var {id, step} = this.$route.params;
        this.init(step);
    }
}
</script>

<style lang="scss">
    .funnel_steps_top .settings_btn {
      position: absolute;
      right: 0;
      top: 15px;
	    padding: 10px 14px;
    }

    .funnel_steps_top .settings_btn:hover svg path {
        fill: #4368E0;
    }
    .product-result-item {
        cursor: pointer;
        & a.list-item-link {
            cursor: pointer;
        }
    }
</style>
